/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportCurrentPrevious } from './reportCurrentPrevious';
import { ReportEnergyAvgPerDay } from './reportEnergyAvgPerDay';
import { ReportEnergyDaily } from './reportEnergyDaily';


export interface ReportEnergy { 
    avg_per_day?: ReportEnergyAvgPerDay;
    total?: ReportCurrentPrevious;
    daily_view?: Array<ReportEnergyDaily>;
}

